import { COMMON } from "./Common";
import { app } from "../lib/app";

export function findUrlHDIfExist(row) {
  try {
    let linkHD = JSON.parse(row.params).hd;
    if (linkHD !== null && linkHD !== undefined) {
      return linkHD;
    } else {
      return row.href;
    }
  } catch (e) {
    return row.href;
  }
}

export function getCloudUrl(url, mes) {
  try {
    if (app.replaceLink.length > 0 && mes) {
      const FIFTEEN_DAYS_MS = 15 * 24 * 60 * 60 * 1000;
      const now = Date.now();
      let filter = app.replaceLink.find((m) => m.msgId == mes.id.msgId);
      if (filter && (now - mes.ts) >= FIFTEEN_DAYS_MS) {
        return filter.link;
      }
    }
  } catch (e) {
    return url
  }
  return url;
}

export function convertData(resp = []) {
  return resp.reduce((obj, item) => {
    let data = {};
    data.raw = item
    let row = JSON.parse(item.content);
    data.thumb = row.thumb;
    data.ts = item.ts;
    if (item.msgType === COMMON.CHAT_PHOTO) {
      data.src = getCloudUrl(findUrlHDIfExist(row), item);
      data.thumb = data.src;
      data.msgType = COMMON.CHAT_PHOTO;
      return [...obj, data];
    }
    if (item.msgType === COMMON.CHAT_VIDEO) {
      data.msgType = COMMON.CHAT_VIDEO;
      data.sources = [];
      let srcVideo = {};
      srcVideo.src = findUrlHDIfExist(row);
      srcVideo.type = row.type !== "" ? row.type : "video/mp4";
      data.sources.push(srcVideo);
      data.type = "video";
      let params = JSON.parse(row.params);
      data.width = params.video_width;
      data.height = params.video_height;
      data.autoplay = false;
      return [...obj, data];
    }
  }, []);
}

export function isObjectEmpty(obj) {
  if (typeof obj !== 'object' || obj === null) {
      return false;
  }
  return Object.keys(obj).length === 0;
}